import { getField } from 'vuex-map-fields';

export default {
  teamsLoaded: state => state.teamsLoaded,
  teamList: state => state.teamList,
  teamSaved: state => state.teamSaved,
  teamDeleted: state => state.teamDeleted,
  apiError: state => state.apiError,
  getField,
};
